import FeaturesContainer from './FeaturesContainer'

const PunicButton = ({ history }) => {
    return <FeaturesContainer history={history} pageName={'panic_button'} nextUrl={'choose-your-target'} pageEvent={'onboardingSos'} clickEvent={'onboardingSosSubmitted'} />
};

export default PunicButton
